// react library imports
import { useSelector } from 'react-redux';
import { ChalkboardTeacher, PlusCircle } from 'phosphor-react';

// import navigation data and local component
import {navigation} from './data';
import NavigationCard from './NavigationCard';

// redux store imports
import { useGetClassListQuery } from 'api/class/class';
import { getPreschoolInformation } from 'Redux/preschool/preschool';

const Navigation = ({active}) => {
    // fetch data from redux store
    const preschoolInformation = useSelector(getPreschoolInformation)

    // define query params
    const params ={
      preschool_id : preschoolInformation?.id
    }
    // fetch data from api using rtk query
    const {data} =  useGetClassListQuery(params)         
    // manipulate navigation using class list
    const classesNavItem = navigation.find(item => item.name === "Classes");

    if (classesNavItem) {
        // Map through the data array and create sub-navigation items
        const subNavigationItems = data?.map((item, index) => ({
            id: `3.${index + 2}`,
            title: item.class_name,
            path: `classes/${item.id}`,
            logo: <ChalkboardTeacher className='page_sub_navigation_icon' weight='fill' />,
            classId:item.id,
            class_information:item,
          }));
          
          // Create the addClass object
          const addClass = {
            id: `3.${subNavigationItems?.length ? subNavigationItems?.length + 4:1}`,
            title: "Add New Class",
            path: "classes/add-new-class",
            logo: <PlusCircle className='page_sub_navigation_icon' weight='fill' />
          };
          
          // Assign subItem based on whether subNavigationItems is empty or not
          const subItem = subNavigationItems?.length > 0 ? [...subNavigationItems, addClass] : [addClass];
          classesNavItem.subNavigation = subItem;
          classesNavItem.path=subItem?.length >0 ? subItem[0]["path"]:"classes"
          classesNavItem.classId=subItem?.length >0 ? subItem[0]["classId"]:"classes"
        }
  return (
    <main className='side_bar_navigation mues_column_space_between'>
      {navigation.map(item=>(
        <NavigationCard item={item} key={item.id}
        active={active}/>
      ))}
	</main>
  )
}

export default Navigation